import { IProductCenter, IProfitCenter } from "interfaces/product-center";
import { applyQueryString } from "lib/queryString";
import { apiGeneral } from "services";

export function useProductCenter() {
  const getListProductCenters = async (
    filters: any
  ): Promise<IProductCenter[]> => {
    const url = applyQueryString(`/product-center`, {
      ...filters,
    });
    const { data } = await apiGeneral.get<IProductCenter[]>(url);

    return data;
  };

  const createProductCenter = async (
    data: Partial<IProductCenter>
  ): Promise<void> => {
    await apiGeneral.post("/product-center", data);
  };

  const deleteProductCenter = async (id: number): Promise<void> => {
    await apiGeneral.delete(`/product-center/${id}`);
  };

  const associateProfitCenter = async (
    id: number,
    data: Partial<IProfitCenter>
  ): Promise<void> => {
    await apiGeneral.post(`/product-center/profit/${id}`, data);
  };

  const deleteProfitCenter = async (id: number): Promise<void> => {
    await apiGeneral.delete(`/product-center/profit/${id}`);
  };

  return {
    getListProductCenters,
    createProductCenter,
    deleteProductCenter,
    associateProfitCenter,
    deleteProfitCenter,
  };
}
